import * as React from 'react'
import '../../../trident-campaigns/common/TridentCampaignView.scss';
import './TridentTemplateCard.scss';


type Props = {
  title: string,
  templateType: string,
  description: string,
  icon: string,
  onTemplateSelected: Function,
  isActive: boolean,
};


export class TridentTemplateCard extends React.Component {
  props: Props;

  constructor(props: Props) {
    super(props);
  }

  render() {
    const {icon, title, templateType, description, onTemplateSelected, isActive} = this.props;
    let className = "card-container";
    if (isActive) {
      className = "card-container" + " card-active"
    }
    return (
      <div className={className} onClick={() => {onTemplateSelected(templateType)}}>
        <img src={icon} height={'48px'} width={'48px'} alt={''}/>
        <div className={"text-container"}>
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
      </div>
    );
  }
}

export default TridentTemplateCard
